export const en = {
    action_submit: 'Appoint',
    grant_to: 'Employee',
    title: 'Appoint coordinator role',
};
